<template>
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
  >
    <path d="M6.24665 0C3.76137 0 1.74665 2.01472 1.74665 4.5V6.9014L0.782346 9.31446C0.720789 9.4685 0.739637 9.64304 0.832658 9.78038C0.925679 9.91773 1.08076 10 1.24665 10H4.24664C4.24664 11.1084 5.13829 12 6.24664 12C7.355 12 8.24664 11.1084 8.24664 10H11.2466C11.4125 10 11.5676 9.91773 11.6606 9.78038C11.7537 9.64304 11.7725 9.4685 11.7109 9.31446L10.7467 6.9014V4.5C10.7467 2.01472 8.73193 0 6.24665 0ZM7.24664 10C7.24664 10.5561 6.80271 11 6.24664 11C5.69057 11 5.24664 10.5561 5.24664 10H7.24664ZM2.74665 4.5C2.74665 2.567 4.31365 1 6.24665 1C8.17965 1 9.74665 2.567 9.74665 4.5V6.9976C9.74665 7.06116 9.75877 7.12413 9.78235 7.18315L10.5084 9H1.9849L2.71095 7.18315C2.73453 7.12413 2.74665 7.06116 2.74665 6.9976V4.5Z" />
  </svg>
</template>
